export const DEFAULT_SETTINGS = {
  deadline: 20,
  slippage: 0.5
};

export const SETTINGS_STORAGE_KEY = 'kizuma_app_settings';
export const NFT_TOKENS_KEY = 'kizuma_nft_tokens';
